import React, { useEffect } from "react";
import { message } from "antd";

import { useAuthStore } from "../store";
import mixpanelService from "../services/mixpanel";
import AuthPageShell from "../components/forms/AuthPageShell";
import AuthSuccessScene from "../components/forms/AuthSuccessScene";
import { useValidSSO } from "../hooks/useValidSSO";

const LoginSuccess = () => {
  useValidSSO()
  const userData = useAuthStore((s) => s.userData);

  useEffect(() => {
    message.destroy();
  }, []);

  useEffect(() => { 
    mixpanelService.people.set_once('First Sign-In', {
      userData
    });
  },[userData])

  return (
    <AuthPageShell variant="success">
      <AuthSuccessScene
        title="You're in"
        subtitle="Signed in successfully. Taking you to Tripplo…"
        area="login-success"
      />
    </AuthPageShell>
  );
}

export default LoginSuccess;
